import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { formatMessage } from "devextreme/localization";

@Component({
  selector: "app-upload",
  templateUrl: "./upload.component.html",
  styleUrls: ["./upload.component.scss"],
})
export class UploadComponent implements OnInit {
  formatMessage = formatMessage;
  orderId: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.orderId = params.get("id") || "";
    });
  }
}
